<template>
 <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <pre>{{ banner.id }}</pre>
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Banner</span>
        <h3 class="page-title d-inline">{{ banner.id !== null ? 'Editar' : 'Novo' }}</h3>
        <router-link v-if="banner.id !== null" class="btn btn-success text-white float-right " :to="{ name: 'admin-banner-new' }">Novo jogo</router-link>
      </d-col>
    </d-row>
    <!-- Content -->
    <d-row>
      <d-col cols="12" class="col-md">
        <d-card class="mb-4 card-small">
          <!-- Card Header -->
          <d-card-header class="border-bottom">
            <d-row class="align-items-center">
              <d-col cols="12" lg="6">
                <h6 class="m-0">Dados cadastrais</h6>
              </d-col>
            </d-row>
          </d-card-header>

          <d-list-group flush>
            <d-list-group-item class="p-3">
              <d-row>
                <d-col>
                  <banner-form ref="bannerFormRef" />
                </d-col>
              </d-row>
            </d-list-group-item>
          </d-list-group>
        </d-card>
      </d-col>
      <!-- Sidebar Widgets -->
      <d-col lg="auto" sm="12" class="position-relative sidebar-publish">
        <d-card class="mb-3 card-small position-sticky">
          <d-card-header class="border-bottom d-flex justify-content-between align-items-center">
            <h6 class="m-0">Publicação</h6>
            <d-button @click="draft" type="button" class="btn-sm btn-outline-accent col-5">Rascunho</d-button>
          </d-card-header>

          <d-card-body class="px-0">
            <d-list-group flush>
              <d-list-group-item class="px-3 py-0 dates">
                <div class="pb-1">Status: <span>{{ status }}</span></div>
                <div class="pb-1">
                  Publicado em:
                  <template v-if="editPublishDate">
                    <datepicker
                      class="mb-2"
                      type="datetime"
                      format="DD/MM/YYYY | HH:mm"
                      :model.sync="dateTime"
                    />
                  </template>
                  <span v-else>{{ banner.f_published_date }}</span>
                  <a class="edit" @click="togglePublishDate">
                    <template v-if="editPublishDate">Cancelar</template>
                    <template v-else>Editar</template>
                  </a>
                  <d-button v-if="editPublishDate" @click="savePublish" type="button" class="py-0 ml-2 btn btn-outline-info btn-sm">Ok</d-button>
                </div>
              </d-list-group-item>
            </d-list-group>
          </d-card-body>

          <d-card-footer class="border-top d-flex justify-content-around">
            <d-button
              @click="publish"
              type="button"
              class="btn-primary mb-xl-0 col-5 col-xl-5"
              v-if="banner.status_id !== 2"
            >Publicar</d-button>
            <d-button
              @click="save"
              type="button"
              class="btn-primary mb-xl-0 col-5 col-xl-5"
              v-else
            >Salvar</d-button>
            <router-link
              class="text-white btn-secondary btn col-xl-5 col-5"
              :to="{ name: 'admin-banner-list', params: { page: 1 } }"
            >Cancelar</router-link>
          </d-card-footer>
        </d-card>
      </d-col>
    </d-row>
 </d-container>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import Events from '_utils/events';
import config from '_config';
import { cloneDeep, getDateByFormatedDate } from '_utils';
import Datepicker from '_shared/Datepicker.vue';
import BannerForm from '../components/BannerForm.vue';
import { MODEL, _LOAD_MODEL_ } from '../components/BannerModel';

export default {
  name: 'banner-page',
  components: {
    BannerForm,
    Datepicker,
  },
  computed: {
    banner() {
      const { bannerEdit } = this.$store.state.banner;
      if (bannerEdit) {
        Events.$emit(_LOAD_MODEL_, bannerEdit);
        return bannerEdit;
      }
      return cloneDeep(MODEL);
    },
    status() {
      if (this.banner.status_id === 2) {
        const date = getDateByFormatedDate(this.banner.published_date);
        const now = new Date();
        if (date > now) {
          return 'Agendado';
        }
      }
      return this.banner.status.name;
    },
    siteUrl() {
      return config.SITE_URL;
    },
  },
  data() {
    return {
      editPublishDate: false,
      dateTime: null,
    };
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === 'admin-banner-new') {
          Events.$emit(_LOAD_MODEL_, cloneDeep(MODEL));
          this.setBanner(cloneDeep(MODEL));
        }
      },
    },
  },
  methods: {
    ...mapActions([
      'getBanner',
    ]),
    ...mapMutations(['setBanner']),
    draft() {
      this.$refs.bannerFormRef.draft();
    },
    save() {
      this.$refs.bannerFormRef.save();
    },
    publish() {
      this.$refs.bannerFormRef.publish();
    },
    togglePublishDate() {
      this.dateTime = getDateByFormatedDate(this.banner.published_date);
      this.editPublishDate = !this.editPublishDate;
    },
    savePublish() {
      this.banner.status_id = 2;
      this.banner.published_date = this.dateTime;
      Events.$emit(_LOAD_MODEL_, this.banner);
      this.$store.commit('setPuzzle', this.banner);
      this.$refs.bannerFormRef.save();
      this.editPublishDate = false;
    },
  },
  mounted() {
    if (this.$route.params.bannerId) {
      this.getBanner(parseInt(this.$route.params.bannerId, Number))
        .then(response => {
          Events.$emit(_LOAD_MODEL_, response);
        });
    }
    this.$store.commit('setBanner', cloneDeep(MODEL));
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/overrides';

.sidebar-publish {
  .card-small {
    min-width: 290px;
  }
  .position-sticky {
    top: 80px;
  }
  .dates {
    span {
      font-size: 12px;
      font-weight: bold;
    }
    a {
      margin-left: 5px;
      color: $primary;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
